var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgForm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "form_svg__icon",
    d: "M21.75 3a.75.75 0 01.75.75v16.5a.75.75 0 01-.75.75H2.25a.75.75 0 01-.75-.75V3.75A.75.75 0 012.25 3h19.5zm0-1.5H2.25A2.25 2.25 0 000 3.75v16.5a2.25 2.25 0 002.25 2.25h19.5A2.25 2.25 0 0024 20.25V3.75a2.25 2.25 0 00-2.25-2.25zM6 6a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm0 4.5a1.5 1.5 0 100 3 1.5 1.5 0 000-3zM6 15a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm13.5-6.938V6.938a.281.281 0 00-.281-.282H9.28A.281.281 0 009 6.938v1.125a.281.281 0 00.281.28h9.938a.281.281 0 00.281-.28zm0 4.5v-1.124a.281.281 0 00-.281-.282H9.28a.281.281 0 00-.281.281v1.126a.281.281 0 00.281.28h9.938a.281.281 0 00.281-.28zm0 4.5v-1.125a.281.281 0 00-.281-.28H9.28a.281.281 0 00-.281.28v1.126a.281.281 0 00.281.28h9.938a.281.281 0 00.281-.28z",
    fill: "#C4C4C4"
  })));
}

export default __webpack_public_path__ + "./fonts/form.a8d397e39745b7947aee225034fa875f.svg";
export { SvgForm as ReactComponent };